module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-14.106db2f9.png";